import { Box, Button, Stack, Typography, alpha } from '@mui/material';
import { ArrowForward, TrendingDown, TrendingUp } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { deviationBaselineLabels, deviationGranularityLabels, type ConsumptionDeviationAlert } from '@/helpers/consumptionDeviations';
import { convertDate, formatConsumption } from '@/helpers/misc';

const ConsumptionDeviationAlertCard = ({ alert, showBuildingName = false, onOpen }: {
  alert: ConsumptionDeviationAlert; showBuildingName?: boolean; onOpen?: () => void;
}) => {
  const TrendIcon = alert.direction === 'spike' ? TrendingUp : TrendingDown;
  return (
    <Box sx={{ containerType: 'inline-size', border: 1, borderColor: 'warning.main', bgcolor: (theme) => alpha(theme.palette.warning.main, 0.06), borderRadius: 2, p: 1.5, minWidth: 0 }}>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr)',
        alignItems: 'center',
        gap: 1.5,
        '& > *': { minWidth: 0, overflowWrap: 'anywhere' },
        '@container (min-width: 600px)': {
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        },
        '@container (min-width: 1000px)': {
          gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.4fr) auto',
          '& > :not(:first-child)': {
            borderLeft: 1,
            borderColor: 'warning.main',
            pl: 2,
          },
        },
      }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <TrendIcon sx={{ color: 'warning.main', flexShrink: 0 }} />
          <Typography variant="subtitle2" fontWeight={700} sx={{ overflowWrap: 'anywhere' }}>
            {alert.direction === 'spike' ? 'Růst' : 'Pokles'} spotřeby: {alert.collectionPointName}
          </Typography>
        </Stack>
        <Box>
          {showBuildingName ? <Typography variant="caption" color="text.secondary" display="block">Objekt: {alert.buildingName}</Typography> : null}
          <Typography variant="body2">
            {deviationGranularityLabels[alert.snapshot.granularity]} spotřeba: <strong>{formatConsumption(alert.snapshot.value, alert.snapshot.unit)}</strong>
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block">{convertDate(alert.snapshot.from)} – {convertDate(alert.snapshot.to)}</Typography>
        </Box>
        <Stack spacing={1}>
          {alert.snapshot.comparisons.filter((comparison) => comparison.breached).map((comparison) => (
            <Box key={comparison.baseline}>
              <Typography variant="caption" color="text.secondary" display="block">{deviationBaselineLabels[comparison.baseline]}</Typography>
              <Typography variant="body2">
                Očekáváno {formatConsumption(comparison.expected, alert.snapshot.unit)};{' '}
                <strong>{comparison.changePercent > 0 ? '+' : ''}{comparison.changePercent.toLocaleString('cs-CZ', { maximumFractionDigits: 1 })} %</strong>
                {' '}({comparison.changeAbsolute > 0 ? '+' : ''}{formatConsumption(comparison.changeAbsolute, alert.snapshot.unit)})
              </Typography>
            </Box>
          ))}
        </Stack>
        <Box sx={{ display: 'flex', '@container (min-width: 600px)': { justifyContent: 'flex-end' } }}>
          <Button component={Link} to={alert.actionPath} onClick={onOpen} size="small" endIcon={<ArrowForward />}>Otevřít odběrné místo</Button>
        </Box>
      </Box>
    </Box>
  );
};
export default ConsumptionDeviationAlertCard;
